import dynamic from 'next/dynamic';

export const Iframe = dynamic(/* webpackChunkName: 'iframe' */ import('./index'));
